module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Theater theme-dk"
  }, [_c('div', {
    staticClass: "Theater-stage"
  }, [(_vm.activeItem.type === 'vimeo') ? _c('vimeo', _vm._b({
    key: _vm.activeItem.hash,
    staticClass: "Theater-activeItem"
  }, 'vimeo', _vm.activeItem, false)) : _vm._e(), _vm._v(" "), (_vm.activeItem.type === 'interactive') ? _c('interactive-thumbnail', _vm._b({
    staticClass: "Theater-activeItem"
  }, 'interactive-thumbnail', _vm.activeItem, false)) : _vm._e(), _vm._v(" "), (_vm.activeItem.type === 'smugmug') ? _c('smugmug-album-thumbnail', _vm._b({
    staticClass: "Theater-activeItem Theater-smugmugAlbumThumbnail",
    attrs: {
      "album-key": _vm.activeItem['smugmug-album'],
      "route": {},
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openViewer(_vm.activeItem)
      }
    }
  }, 'smugmug-album-thumbnail', _vm.activeItem, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "Theater-footer"
  }, [_c('div', {
    staticClass: "Theater-info"
  }, [(_vm.activeItem.title || _vm.activeItem.description) ? [(_vm.activeItem.title) ? _c('h1', {
    staticClass: "t-heading-sm c-grey-xxlt"
  }, [_vm._v("\n            " + _vm._s(_vm.activeItem.title) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('break', {
    attrs: {
      "size": "0.25"
    }
  }), _vm._v(" "), (_vm.activeItem.description) ? _c('div', {
    staticClass: "Theater-description",
    domProps: {
      "innerHTML": _vm._s(_vm.activeItem.description)
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "Theater-share"
  }, [_c('share-button', {
    staticClass: "Theater-shareButton"
  }, [_c('share-tab')], 1)], 1), _vm._v(" "), (_vm.data.length > 1) ? _c('div', {
    staticClass: "Theater-selector"
  }, [_c('div', {
    staticClass: "Theater-selectorArrow Theater-selectorArrowPrevious",
    on: {
      "click": _vm.previous
    }
  }, [_c('viewer-button', {
    attrs: {
      "icon": "arrow-left",
      "small": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "slider",
    staticClass: "Theater-selectorSlider"
  }, _vm._l((_vm.data), function(item) {
    return _c('div', {
      staticClass: "Theater-selectorItem",
      class: {
        'Theater-selectorItem--isActive': item.hash === _vm.activeItem.hash
      }
    }, [(item.type === 'vimeo') ? _c('vimeo-thumbnail', {
      staticClass: "Theater-selectorItemThumbnail",
      attrs: {
        "id": item.id,
        "image": item.image,
        "show-tag": false
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "Theater-selectorArrow Theater-selectorArrowNext",
    on: {
      "click": _vm.next
    }
  }, [_c('viewer-button', {
    attrs: {
      "icon": "arrow-right",
      "small": ""
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfb29bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Theater.vue
// module id = 767
// module chunks = 1474